<div class="row justify-content-center">
    <span class="circle-modal animate-grow-circle">
        <img class="info-icon" src="../../../../assets/images/info-icon.svg" alt="Info" />
    </span>
</div>

<div class="pl-lg-8 pr-lg-8 pt-lg-6 pt-0" mat-dialog-content>
    <div class="row mt-3 mb-3 pr-8 pl-8 justify-content-center">
        <span class="title-modal" translate>{{ title }}</span>
    </div>
    <div class="row mt-4 mx-0 justify-content-center">
        <span class="mb-3 text-modal text-center" innerHTML="{{ text | translate }}"></span>
    </div>
</div>

<div class="justify-content-center mt-4" mat-dialog-actions>
    <button
        type="button"
        class="btn btn-default btn-modal-action btn-lg mr-4"
        tabindex="-1"
        (click)="close()"
        translate>
        {{ textBtnClose }}
    </button>
</div>
